'use client';

import React, { FC } from 'react';

import { LocationGroupShowButton } from './GroupShowButton.styled';

interface GroupBackButtonProperties {
  label: string;
  onClick: () => void;
}

export const GroupShowButton: FC<GroupBackButtonProperties> = ({
  label,
  onClick,
  ...props
}) => {
  return (
    <LocationGroupShowButton variant="text" onClick={onClick} {...props}>
      {label}
    </LocationGroupShowButton>
  );
};
